<template>
  <el-dialog title="已解绑/转交详情" :visible.sync="dialogTableVisible" @close="closeDialog">
    <el-table :data="unbind_list" border v-loading="loading">
      <el-table-column property="username" label="去向">
        <template slot-scope="scope">
          <span>{{ scope.row.username ? scope.row.username : '公共线索' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column property="sales_num" label="线索数" width="200"></el-table-column> -->
      <el-table-column property="flag_name" label="操作类型"></el-table-column>
    </el-table>
    <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
  </el-dialog>
</template>
<style scoped>
</style>
<script>
import ClueCount from "~/services/ClueCount";
import MyPagination from "~/widgets/MyPagination.vue";

export default {
  name: "UnbindDialog",

  components: {
    MyPagination,
  },

  props: {
    params:{
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      loading: false,
      // 分页信息
      linkPage: null,
      unbind_list: [],
      dialogTableVisible: false,
      active_name: 'allocation-unbind',
      searcheModel: {},
    };
  },

  mounted() {
    
  },

  created: function () {
    this.dialogTableVisible = true;
    this.searcheModel = _.clone(this.params);
    this.getList(this.searcheModel);
  },

  methods: {
    //获取列表
    getList(params) {
      // loading 动画
      this.loading = true;
      ClueCount.getList(params, this.active_name)
        .then((res) => {
            if (res.code == 0) {
                this.unbind_list = res.data;
            }
            if (res._meta) {
                this.linkPage = res._meta;
            }
            this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },


    handleSizeChange(newSize) {
        // 处理每页条目数变化事件
        let params = this.searcheModel;
        params['perPage'] = newSize;
        this.getList(params);
    },

    handleCurrentChange(newPage) {
        let params = this.searcheModel;
        // 处理当前页码变化事件
        params['page'] = newPage;
        this.getList(params);
    },

    dialogShow(){
        if(this.params.unbind_num == 0){
          return false;
        }
        this.dialogTableVisible = true;
    },

    closeDialog(){
      this.dialogTableVisible = false;
      this.$emit("close", []);
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/views/count/dialog/UnbindDialog.vue